import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const wrapper = css`
    margin: 1rem;
    .row,
    .col {
      margin: 0;
    }
    .col {
      padding: 0;
    }
  `;

  const reviewHeader = css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  `;

  // Same reason as the index: nothing here inherits a heading style, so the
  // h1 carries its own typography.
  const title = css`
    ${theme.typography.h1}
    color: ${theme.colors.navy["1"]};
    margin: 0;
  `;

  const subheading = css`
    color: ${theme.colors.gray.primary};
  `;

  const line = css`
    background-color: ${theme.colors.gray["2"]};
    margin: 1rem 0;
    width: 100%;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
    padding: 1.25em 1em;
  `;

  const summary = css`
    display: flex;
    gap: 3rem;
    margin-bottom: 1rem;
  `;

  const figure = css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  `;

  const figureLabel = css`
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${theme.colors.gray.primary};
  `;

  const figureValue = css`
    ${theme.typography.h2}
    color: ${theme.colors.navy["1"]};
  `;

  // The figures above cover settled services only, so the count that says how
  // much of the project they describe sits directly beneath them.
  const coverage = css`
    display: flex;
    align-items: baseline;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    color: ${theme.colors.gray.primary};
    font-size: 0.875rem;
  `;

  const columnHeader = css`
    font-weight: 600;
  `;

  // This is the sentence that carries the page's honesty about partial data;
  // it should not render as ordinary body text.
  const caveat = css`
    font-size: 0.75rem;
    color: ${theme.colors.gray.primary};
  `;

  const empty = css`
    ${theme.typography.p}
    color: ${theme.colors.gray.primary};
    margin: 0;
  `;

  return {
    wrapper,
    reviewHeader,
    title,
    subheading,
    line,
    card,
    summary,
    figure,
    figureLabel,
    figureValue,
    coverage,
    columnHeader,
    caveat,
    empty,
  };
};

export default useStyles;
